import { dateSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addAttendanceSchema = object().shape({
    session_date: dateSchema,
    attendance: stringRequiredSchema.oneOf(['present', 'absent'])
});

export default addAttendanceSchema;